import React from 'react';
import { translate } from 'react-i18next';

import {
    Button,
    ButtonWithPopover,
    ButtonTypes
} from 'common/components/core/button';
import {
    PopoverPlaceEnum,
    PopoverTriggerEnum
} from 'common/components/core/popover/popOverFactory';
import theme from './SidebarFooter.scss';

const SidebarFooter = ({ t, isMapModified, onSave, onAdd }) => {
    return (
        <div className={theme.sidebarFooter}>
            <ButtonWithPopover
                semibold
                invert
                theme={theme}
                buttonType={ButtonTypes.Icon}
                icon="new-folder"
                onClick={onAdd}
                className={theme.addBtn}
                popOverContent={t('zoneMap.addFolder')}
                place={PopoverPlaceEnum.Right}
                triggerPopoverOn={PopoverTriggerEnum.Hover}
                invertPopover
            />

            <Button
                semibold
                uppercase
                invert
                color="dark-sky-blue"
                theme={theme}
                buttonType={ButtonTypes.Solid}
                label={t('zoneMap.save')}
                onClick={onSave}
                className={theme.saveBtn}
                disabled={!isMapModified}
            />
        </div>
    );
};

export default translate('entityManagement')(SidebarFooter);
